import { Select } from "antd";

const SelectCustom = (props: any) => {

  const { label, className, ...rest } = props;

  return (
    <>
      <div className="mb-0 text-[12px] font-bold">{label}</div>
      <Select
        className={`w-full rounded-md focus:outline-none text-sm bg-gray-50 ${className}`}
        {...rest}
        placeholder="Select"
      />
    </>
  );
};

export default SelectCustom;
